<template>
    <div>
        <div class="mt-2">
            <strong>Colonne</strong>
            <b-input :list="'splitcol' + id" v-model="column" size="sm" />
            <datalist :id="'splitcol' + id">
                <option v-for="(c, ci) in columns_data" :key="'spc' + ci">{{ c }}</option>
            </datalist>
        </div>

        <p class="mt-2">
            Séparateur
            <b-input v-model="separator" placeholder="," />
        </p>

        <p>
            Intervalle
            <small class="text-muted d-block mb-1">Si renseigné et que la colonne contient une plage "début{{ separator }}fin" (ex: 1{{ separator }}10), génère automatiquement toutes les valeurs intermédiaires selon cet intervalle avant de découper</small>
            <b-input type="number" v-model.number="interval" />
        </p>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "split_step",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0) {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            }
        },
        data() {
            return {
                id: uniqueId(""),
                columns_data: [],

                column: "",
                separator: ",",
                interval: null
            };
        },
        methods: {
            save() {
                return {
                    column: this.column,
                    separator: this.separator || ",",
                    interval: this.interval
                };
            },
            async load(data) {
                if (!data) data = {};
                this.column = data.column || "";
                this.separator = data.separator || ",";
                this.interval = data.interval !== undefined ? data.interval : null;
            }
        }
    };
</script>

<style scoped>
</style>
